<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 md10 lg8 p-0>
            <v-card class="fill-height">
                <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs>
                <!--
                <v-card-title>
                    <h2>{{ $t("accessControl") }}</h2>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="usersSearch"
                        append-icon="search"
                        :label="$t('search')"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                -->

                <v-toolbar card prominent dense>
                    <v-tooltip
                        bottom
                        :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                :disabled="!userId"
                                v-on="on"
                                @click="loadACL(userId)"
                            >
                                <v-icon>mdi-reload</v-icon><span
                                    v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                >{{ $t("reload") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("reload") }}</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                :disabled="!userId"
                                v-on="on"
                                @click="saveACL"
                            >
                                <v-icon>mdi-content-save-outline</v-icon><span
                                    v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                >{{ $t("save") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("save") }}</span>
                    </v-tooltip>
                    <v-tooltip
                        bottom
                        :disabled="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                :disabled="!userId"
                                v-on="on"
                                @click="clearACL"
                            >
                                <v-icon>mdi-table-large-remove</v-icon><span
                                    v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.mdAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                >{{ $t("clear") }}</span>
                            </v-btn>
                        </template>
                        <span>{{ $t("clear") }}</span>
                    </v-tooltip>

                    <v-menu bottom left>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                :disabled="!userId"
                                v-on="on"
                            >
                                {{ $t("role") }}
                            </v-btn>
                        </template>

                        <v-list>
                        <v-list-tile
                            v-for="(role, i) in roles"
                            :key="i"
                            @click="applyRole(role)"
                        >
                            <v-list-tile-title>{{ role.title }}</v-list-tile-title>
                        </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>

                <v-card-text class="v-scrollable">
                    <v-layout row wrap>
                        <v-flex xs6>
                            <v-select
                                v-model="companyId"
                                :items="companies"
                                item-text="name"
                                item-value="id"
                                :label="$t('company')"
                                prepend-icon="mdi-office-building-outline"
                                class="pr-3"
                            ></v-select>
                        </v-flex>
                        <v-flex xs6>
                            <v-select
                                v-model="userId"
                                :items="filteredUsers"
                                item-text="fullName"
                                item-value="id"
                                :label="$t('user')"
                                prepend-icon="mdi-account"
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        item-key="module"
                        class="dense-table centered-checkboxes"
                        hide-actions
                    >
                        <template v-slot:headers="props">
                            <tr>
                                <th
                                    v-for="header in props.headers"
                                    :key="header.text"
                                >
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr :active="props.selected" @click="props.selected = !props.selected">
                                <td>{{ props.item.moduleTitle }}</td>
                                <td><v-layout justify-center><v-checkbox v-model="props.item.read"></v-checkbox></v-layout></td>
                                <td class="text-xs-center"><v-checkbox v-model="props.item.create"></v-checkbox></td>
                                <td class="text-xs-center"><v-checkbox v-model="props.item.modify"></v-checkbox></td>
                                <td class="text-xs-center"><v-checkbox v-model="props.item.delete"></v-checkbox></td>
                                <td class="text-xs-center"><v-checkbox v-model="props.item.export"></v-checkbox></td>
                            </tr>
                        </template>
                        <template v-slot:footer>
                            <td></td>
                            <td class="px-0 text-xs-center"><v-btn small @click="toggleAll('read')">{{ $t("all") }}</v-btn></td>
                            <td class="px-0 text-xs-center"><v-btn small @click="toggleAll('create')">{{ $t("all") }}</v-btn></td>
                            <td class="px-0 text-xs-center"><v-btn small @click="toggleAll('modify')">{{ $t("all") }}</v-btn></td>
                            <td class="px-0 text-xs-center"><v-btn small @click="toggleAll('delete')">{{ $t("all") }}</v-btn></td>
                            <td class="px-0 text-xs-center"><v-btn small @click="toggleAll('export')">{{ $t("all") }}</v-btn></td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <message-box ref="MessageBox"/>
        </v-flex>
        <v-alert
            :value="alert !== ''"
            :type="alertType"
            transition="scale-transition"
            class="bottom-alert"
        >
            {{ alert }}
        </v-alert>
    </v-layout>
</template>

<script>
    import MessageBox from "@/components/dialogs/MessageBox";

    export default {
        name: "EditACL",

        inject: ["theme"],

        components: {
            MessageBox
        },

        data () {
            return {
                alert: "",
                alertType: "success",

                breadCrumbs: [
                    { text: "Администрирование", disabled: false },
                    { text: "Контроль доступа",  disbaled: false }
                ],

                selectAll: {
                    read:   false,
                    create: false,
                    modify: false,
                    delete: false,
                    export: false
                },

                headers: [
                    { text: "Module",     align: "left",   "value": "module", selectAll:"z" },
                    { text: "Can read",   align: "center", "value": "read",   selectAll:"canReadAll" },
                    { text: "Can create", align: "center", "value": "create", selectAll:"z" },
                    { text: "Can modify", align: "center", "value": "modify", selectAll:"z" },
                    { text: "Can delete", align: "center", "value": "delete", selectAll:"z" },
                    { text: "Can export", align: "center", "value": "export", selectAll:"z" },
                ],

                items: [],

                loading: {
                    acl:       false,
                    companies: false,
                    users:     false
                },

                roles: [
                    { id: 1, title: "Администратор" },
                    { id: 2, title: "Пользователь" },
                    { id: 3, title: "Пользователь (только чтение)" }
                ],

                userId:      null,
                users:       [],
                usersSearch: "",
                companyId:   0,
                companies:   []
            }
        },

        mounted () {
            this.applyLocale();
            this.loadCompanies();
            this.loadUsers();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });
        },

        computed: {
            filteredUsers() {
                return this.companyId == 0
                    ? this.users
                    : this.users.filter(user => user.companyId == this.companyId);
            },

            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.acl || this.loading.companies || this.loading.users;
            }
        },

        watch: {
            alert (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },

            allReadSelected () {
                let allSelected = true;

                this.items.forEach((item) => {
                    if (!item.read) { allSelected = false; }
                });

                if (this.items.length == 0) { allSelected = false; }

                this.selectAll.read = allSelected;
            },

            companyId () { this.items = []; },

            userId (val) { this.loadACL(val); }
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.headers = [
                    { text: this.$t("module"),    align: "left",   "value": "module", selectAll:"z" },
                    { text: this.$t("aclRead"),   align: "center", "value": "read",   selectAll:"canReadAll"  },
                    { text: this.$t("aclCreate"), align: "center", "value": "create", selectAll:"z" },
                    { text: this.$t("aclModify"), align: "center", "value": "modify", selectAll:"z" },
                    { text: this.$t("aclDelete"), align: "center", "value": "delete", selectAll:"z" },
                    { text: this.$t("aclExport"), align: "center", "value": "export", selectAll:"z" },
                ];

                this.breadCrumbs = [
                    { text: this.$t("administration"), disabled: false },
                    { text: this.$t("accessControl"),  disabled: false }
                ];

                this.roles = [
                    { id: 1, title: this.$t("administrator") },
                    { id: 2, title: this.$t("operator") },
                    { id: 3, title: this.$t("user") },
                    { id: 4, title: `${this.$t("user")} (${this.$t("readOnly")})` }
                ];

                if (this.userId) {
                    this.loadACL(this.userId);
                }
            },

            /**
             * Применение роли
             *
             * @param {object} role Объект описания роли
             */
            applyRole (role) {
                switch (role.id) {
                    case 1: // Администратор
                        this.items.forEach((item) => {
                            item.read   = true;
                            item.create = true;
                            item.delete = true;
                            item.export = true;
                            item.modify = true;
                        });
                        break;
                    case 2: // Оператор
                        this.items.forEach((item) => {
                            if (item.module == "companies" || item.module == "users") {
                                item.read   = false;
                                item.create = false;
                                item.delete = false;
                                item.export = false;
                                item.modify = false;
                            } else if (item.module == "calc" || item.module == "tasks") {
                                item.read   = true;
                                item.create = true;
                                item.delete = false;
                                item.export = true;
                                item.modify = false;
                            } else {
                                item.read   = true;
                                item.create = true;
                                item.delete = true;
                                item.export = true;
                                item.modify = true;
                            }
                        });
                        break;
                    case 3: // Пользователь
                        this.items.forEach((item) => {
                            if (item.module == "companies" || item.module == "users") {
                                item.read   = false;
                                item.create = false;
                                item.delete = false;
                                item.export = false;
                                item.modify = false;
                            } else if (item.module == "calc" || item.module == "patterns" || item.module == "tasks") {
                                item.read   = true;
                                item.create = true;
                                item.delete = false;
                                item.export = true;
                                item.modify = false;
                            } else {
                                item.read   = true;
                                item.create = false;
                                item.delete = false;
                                item.export = true;
                                item.modify = false;
                            }
                        });
                        break;
                    default: // Пользователь (только чтение)
                        this.items.forEach((item) => {
                            if (item.module == "companies" || item.module == "users") {
                                item.read   = false;
                                item.create = false;
                                item.delete = false;
                                item.export = false;
                                item.modify = false;
                            } else if (item.module == "calc" || item.module == "tasks") {
                                item.read   = true;
                                item.create = true;
                                item.delete = false;
                                item.export = false;
                                item.modify = false;
                            } else {
                                item.read   = true;
                                item.create = false;
                                item.delete = false;
                                item.export = false;
                                item.modify = false;
                            }
                        });
                }

            },

            /**
             * Очистка списка контроля доступа
             */
            clearACL () {
                this.items.forEach((item) => {
                    item.read   = false;
                    item.create = false;
                    item.delete = false;
                    item.export = false;
                    item.modify = false;
                });
            },

            /**
             * Загрузка списка контроля досупа
             *
             * @param {number} userId Идентификатор пользователя
             */
            loadACL (userId) {
                this.loading.acl = true;

                this.axios.get(
                    `${this.$config.apiURL}acl/${userId}/`,
                    { withCredentials: true }
                ).then(response => {
                    if (response.data.status == "success") {
                        let data   = response.data.acl
                        let ACLMan = this;
                        this.items = [];
                        data.forEach((ACL) => {
                            ACLMan.items.push({
                                moduleId:    ACL.Module.id,
                                module:      ACL.Module.Name,
                                moduleTitle: ACLMan.$t(ACL.Module.Name),
                                read:        ACL.Read,
                                create:      ACL.Create,
                                modify:      ACL.Modify,
                                delete:      ACL.Delete,
                                export:      ACL.Export
                            });
                        });
                    }

                    let allReadSelected   = true;
                    let allCreateSelected = true;
                    let allModifySelected = true;
                    let allDeleteSelected = true;
                    let allExportSelected = true;

                    this.items.forEach((item) => {
                        if  (!item.read)  { allReadSelected   = false; }
                        if (!item.create) { allCreateSelected = false; }
                        if (!item.modify) { allModifySelected = false; }
                        if (!item.delete) { allDeleteSelected = false; }
                        if (!item.export) { allExportSelected = false; }
                    });

                    this.selectAll = {
                        read:   allReadSelected,
                        create: allCreateSelected,
                        modify: allModifySelected,
                        delete: allDeleteSelected,
                        export: allExportSelected
                    }

                    this.loading.acl = false;
                })
                .catch(error => {
                    this.$debug.error(error);

                    this.loading.acl = false;

                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) {
                            this.dialogWatcher();
                        }

                        /* Отслеживание ответа в диалоге "Да/Нет" */
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => {
                                window.location.reload();
                            }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadACL") + ". " + this.$t("subscriptionExpired"));

                        this.setEmptyACL();
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadACL"));

                        this.setEmptyACL();
                    }
                });
            },

            /**
             * Загрузка списка компаний
             */
            loadCompanies () {
                this.loading.companies = true;

                this.axios.get(
                    this.$store.getters.user.role == 3 ? `${this.$config.apiURL}companies/` : `${this.$config.apiURL}companies/${this.$store.getters.user.company.id}/`,
                    { withCredentials: true }
                ).then(response => {
                    if (response.data.status == "success") {
                        let companiesInfo = response.data.companies == undefined ? [response.data.company] : response.data.companies;

                        this.companies = [];

                        companiesInfo.forEach((company) => {
                            this.companies.push({
                                id:   company.id,
                                name: company.Name,
                            });

                            if (this.$store.getters.user.role < 3) {
                                this.companyId = company.id;
                            }
                        });
                    }

                    this.companies.sort((a, b) => {
                        return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
                    });

                    this.companies.unshift({
                        id:   0,
                        name: this.$t("all")
                    });

                    this.loading.companies = false;
                })
                .catch(error => {
                    this.$debug.error(error);

                    this.loading.companies = false;

                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserData") + ". " + this.$t("subscriptionExpired"));
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUsersData") + ". " + this.$t("accessDenied"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadCompaniesData"));
                    }
                });
            },

            /**
             * Загрузка списка пользователей
             */
            loadUsers () {
                this.loading.users = true;

                this.axios.get(
                    `${this.$config.apiURL}users/`,
                    { withCredentials: true }
                ).then(response => {
                    if (response.data.status == "success") {
                        let usersInfo = response.data.users

                        this.users    = [];

                        usersInfo.forEach((user) => {
                            let fullName = (
                                  (user.LastName.trim().length > 0   ? user.LastName.trim()   + " " : "")
                                + (user.FirstName.trim().length > 0  ? user.FirstName.trim()  + " " : "")
                                + (user.MiddleName.trim().length > 0 ? user.MiddleName.trim() + " " : "")
                                + "(" + user.EMail + ")"
                            ).trim();

                            this.users.push({
                                id:         user.id,
                                company:    user.Company.Name.trim(),
                                companyId:  user.Company.id,
                                fullName:   fullName,
                                firstName:  user.FirstName.trim(),
                                middleName: user.MiddleName.trim(),
                                lastName:   user.LastName.trim(),
                                eMail:      user.EMail.trim()
                            });
                        });

                        this.users.sort((a, b) => {
                            return a.fullName.toLowerCase() < b.fullName.toLowerCase() ? -1 : 1;
                        });
                    }

                    this.loading.users = false;
                })
                .catch(error => {
                    this.$debug.error(error);

                    this.loading.users = false;

                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserData") + ". " + this.$t("subscriptionExpired"));
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUsersData") + ". " + this.$t("accessDenied"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUsersData"));
                    }
                });
            },

            /**
             * Сохранение списка контроля доступа
             */
            saveACL () {
                this.loading.acl = true;

                this.axios({
                    method: "patch",
                    url: `${this.$config.apiURL}acl/`,
                    data: {
                        userId: this.userId,
                        acl:    this.items
                    },
                    withCredentials: true
                }).then(response => {
                    let r_data = response.data;

                    if (r_data.status == "success") {
                        this.alertType = "success";
                        this.alert     = this.$t("aclUpdated");
                        //this.showMessageBox(this.$t("information"), this.$t("aclUpdated"));
                        this.dataUpdated = true;
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateACL"));
                    }

                    this.loading.acl = false;
                }).catch(error => {
                    this.$debug.error(error);

                    this.loading.acl = false;

                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) {
                            this.dialogWatcher();
                        }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            (val) => {
                                if (val) {
                                    window.location.reload();
                                }
                            }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateACL") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateACL"));
                    }
                });
            },

            /**
             *  Сброс списка контроля доступа
             */
            setEmptyACL () {
                this.loading.acl = true;

                this.axios.get(
                    `${this.$config.apiURL}acl/modules/`,
                    { withCredentials: true }
                ).then(response => {
                    if (response.data.status == "success") {
                        let modulesInfo = response.data.modules;

                        this.items = [];
                        modulesInfo.forEach((module) => {
                            this.items.push({
                                moduleId:    module.id,
                                module:      module.Name,
                                moduleTitle: this.$i18n.t(module.Name),
                                create:      false,
                                delete:      false,
                                export:      false,
                                modify:      false,
                                read:        false
                            });
                        });
                    }

                    this.loading.acl = false;
                })
                .catch(error => {
                    this.$debug.error(error);

                    this.loading.acl = false;

                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadModulesData") + ". " + this.$t("subscriptionExpired"));
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadModulesData") + ". " + this.$t("accessDenied"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadModulesData"));
                    }
                });
            },

            /**
             * Отображает сообщение
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Переключает все права доступа на указанный модуль
             *
             * @param {string} selModule Выбранный модуль
             */
            toggleAll (selModule) {
                this.selectAll[selModule] = !this.selectAll[selModule];
                this.items.forEach((item) => {
                    item[selModule] = this.selectAll[selModule];
                });
            }
        }
    }
</script>

<style lang="sass" scoped>
    .layout.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 144px)
</style>
